import React from 'react';

// Components
import WpReactions from '../WpReactions';

const ReactionsDocs = () => {
  const reactions = [
    { data: 'rocket', userId: 123, slug: 'x123', createdAt: '2022-09-14T16:55:08.867-07:00' },
    { data: 'heart', userId: 456, slug: 'x847', createdAt: '2022-09-14T16:48:08.867-07:00' },
  ];

  const users = [
    {
      id: 123,
      displayName: 'Josh S',
      avatar: {
        color: '#D41C8A',
        initials: 'JS',
        profilePictureUrl: null,
        label: 'Josh S',
      },
    },
    {
      id: 456,
      displayName: 'Wihan S',
      avatar: {
        color: '#5C6ECB',
        initials: 'WN',
        profilePictureUrl: null,
        label: 'Wihan S',
      },
    },
  ];

  const handleAddReaction = emoji => {
    console.log('-- adding reaction', emoji);
  };

  const handleRemoveReaction = emoji => {
    console.log('-- removing reaction', emoji);
  };

  return (
    <>
      <WpReactions
        currentUserId={123}
        users={users}
        reactions={reactions}
        onAddReaction={handleAddReaction}
        onRemoveReaction={handleRemoveReaction}
      />
    </>
  );
};

export default ReactionsDocs;
